import React, { useState, useEffect, useRef } from "react";
import { Grid, Button, Box } from "@material-ui/core";

import { registerAllModules } from "handsontable/registry";
import Provice_Stamp_Duty_Table from "../NewInvoice/Tables/Provice_Stamp_Duty_Table";
import FCA_Details_Table from "../NewInvoice/Tables/FCA_Details_Table";
import AGREEMENT_Details_Table from "../NewInvoice/Tables/Agreement_Details_Table";
import Heading from "../../../StyledComponents/Heading/Heading";

registerAllModules();

const DepartmentCoordinatorRent = ({ formState, setFormState, show, reviwerFlag, role }) => {
  
  return (
    <Grid container>
      <Grid
  item
  xs={12}
  sm={12}
  md={12}
  lg={12}
  style={{ width: "100%", zIndex: "0" }} // ← FIXED!
>

        {/* <Stack sx={{ width: "100%", color: "grey.500" }} spacing={2}>
             <LinearProgress color="info" />
             <LinearProgress color="info" />
             <LinearProgress color="info" />
  </Stack> */}
     
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                              <Heading title = "Stamp Duty" />
                             <Provice_Stamp_Duty_Table
                               formState={formState}
                               setFormState={setFormState}
                               show={false}
                               reviwerFlag={reviwerFlag}
                               role={role}                        />
                           </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                             <Heading title="PAYMENT DETAILS" />
                             <FCA_Details_Table
                               formState={formState}
                               setFormState={setFormState}
                               show={false}
                               reviwerFlag={reviwerFlag}
                               role={role}                     />
                           </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                             <Heading title="AGREEMENT DETAILS" />
                             <AGREEMENT_Details_Table
                               formState={formState}
                               setFormState={setFormState}
                               show={false}
                                reviwerFlag={reviwerFlag}
                               role={role}    />
                           </Grid>
       
      </Grid>
    </Grid>
  );
};

export default React.memo(DepartmentCoordinatorRent);
